import PaymentSuccessPage from '@/app/payment-success/page';

export const PaymentSuccessPageContainer: React.FC<{className: string}> = ({ 
    className = '',
  }) => {
    return (
        <div className={`toutix-whitelabel ${className}`}>
            <PaymentSuccessPage/>
        </div>
    );
};